'use client'
import { useEffect } from 'react'
import ModalHeader from './ModalHeader'

const Modal = (props) => {
    const { modal, setModal, modalSize = null, children, headerTitle, childMainClass, childMainModalClass } = props;

    const handleOutsideClick = (e) => {
        if (e.target.id === "modal-overlay") {
            setModal(null);
        }
    };

    useEffect(() => {
        const handleKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                setModal?.(null);
            }
        };
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, [setModal]);

    return (
        <div
            id="modal-overlay"
            className={`fixed inset-0 z-[70] flex items-center justify-center bg-neutral-900/40 backdrop-blur-xl animate-fade-in ${childMainModalClass ?? ""}`}
            onClick={handleOutsideClick}
        >
            <div
                className={`${modalSize ?? ""} bg-white rounded-modal relative max-sm:mx-4 shadow-pop border border-white/60 animate-scale-in`}
                onClick={(e) => e.stopPropagation()}
            >
                {headerTitle && <ModalHeader setModal={setModal} headerTitle={headerTitle} />}
                <div
                    className={`rounded-modal overflow-hidden p-6 ${childMainClass ?? ""}`}
                >
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Modal
